import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	doneIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inProgressIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	toDoIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	doneIssuesIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inProgressIssuesIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	toDoIssuesIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningIssuesIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	doneIssues: {
		id: 'version-progress.issue-progress-details.done-issues',
		defaultMessage: '<b>Done: </b><s>{count} {count, plural, one {issue} other {issues}}</s>',
		description: 'Label of the done progress bar displaying how many done issues exist',
	},
	inProgressIssues: {
		id: 'version-progress.issue-progress-details.in-progress-issues',
		defaultMessage:
			'<b>In progress: </b><s>{count} {count, plural, one {issue} other {issues}}</s>',
		description:
			'Label of the in-progress progress bar displaying how many in-progress issues exist',
	},
	toDoIssues: {
		id: 'version-progress.issue-progress-details.to-do-issues',
		defaultMessage: '<b>To do: </b><s>{count} {count, plural, one {issue} other {issues}}</s>',
		description: 'Label of the to-do progress bar displaying how many to-do issues exist',
	},
	warningIssues: {
		id: 'version-progress.issue-progress-details.warning-issues',
		defaultMessage: '<b>Warning: </b><s>{count} {count, plural, one {issue} other {issues}}</s>',
		description: 'Label of the warnings progress bar displaying how many warnings exist',
	},
	doneIssuesIssueTerminologyRefreshM4: {
		id: 'version-progress.issue-progress-details.done-issues-issue-terminology-refresh-m4',
		defaultMessage:
			'<b>Done: </b><s>{count} {count, plural, one {work item} other {work items}}</s>',
		description: 'Label of the done progress bar displaying how many done issues exist',
	},
	inProgressIssuesIssueTerminologyRefreshM4: {
		id: 'version-progress.issue-progress-details.in-progress-issues-issue-terminology-refresh-m4',
		defaultMessage:
			'<b>In progress: </b><s>{count} {count, plural, one {work item} other {work items}}</s>',
		description:
			'Label of the in-progress progress bar displaying how many in-progress issues exist',
	},
	toDoIssuesIssueTerminologyRefreshM4: {
		id: 'version-progress.issue-progress-details.to-do-issues-issue-terminology-refresh-m4',
		defaultMessage:
			'<b>To do: </b><s>{count} {count, plural, one {work item} other {work items}}</s>',
		description: 'Label of the to-do progress bar displaying how many to-do issues exist',
	},
	warningIssuesIssueTerminologyRefreshM4: {
		id: 'version-progress.issue-progress-details.warning-issues-issue-terminology-refresh-m4',
		defaultMessage:
			'<b>Warning: </b><s>{count} {count, plural, one {work item} other {work items}}</s>',
		description: 'Label of the warnings progress bar displaying how many warnings exist',
	},
});
